function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { decorateRangeFacet, PriceFacet } from '@process-creative/slate-ajax-collection';
import { printMoney } from '@process-creative/slate-theme-tools';
export var ATTR_NAV_SLIDER_RANGE = 'data-slider-range';
export var SELECTOR_FACETED_NAV_SLIDER = "[".concat(ATTR_NAV_SLIDER_RANGE, "]");
var decorateSlideFacet = function decorateSlideFacet(FacetType) {
  return decorateRangeFacet( /*#__PURE__*/function (_FacetType) {
    _inherits(_class, _FacetType);
    var _super = _createSuper(_class);
    function _class(params) {
      var _this;
      _classCallCheck(this, _class);
      _this = _super.call(this, _objectSpread(_objectSpread({}, params), {}, {
        options: ['min-max']
      }));
      _this.noUiSlider = params.noUiSlider;
      if (!_this.noUiSlider) {
        throw new Error("Missing noUiSlider optional dependency, make sure you do 'yarn add nouislider' and pass it as a param of this constructor");
      }
      _this.drawSlider();
      return _this;
    }
    _createClass(_class, [{
      key: "getRange",
      value: function getRange() {
        var settings = this.filter.getSettings();
        settings = settings.length ? settings[0] : 'min-max';
        return settings.split('-');
      }
    }, {
      key: "getPrint",
      value: function getPrint() {
        var range = this.getRange();
        return "<div class=\"c-collection-faceted-nav__price-group\">\n        <div ".concat(ATTR_NAV_SLIDER_RANGE, "></div>\n          <form>\n            <input type=\"hidden\" name=\"min-value\" value=\"\">\n            <input type=\"hidden\" name=\"max-value\" value=\"\">\n          </form>\n\n          <div class=\"noUi-results\">\n            ").concat(this.formatRange(range[0], range[1]), "\n          </div>\n      </div>");
      }
    }, {
      key: "getRangeMin",
      value: function getRangeMin() {
        return this.filter.getRangeMin ? this.filter.getRangeMin() : 0;
      }
    }, {
      key: "getRangeMax",
      value: function getRangeMax() {
        return this.filter.getRangeMin ? this.filter.getRangeMax() : 100;
      }
    }, {
      key: "print",
      value: function print() {
        _get(_getPrototypeOf(_class.prototype), "print", this).call(this);
        this.drawSlider();
      }
    }, {
      key: "drawSlider",
      value: function drawSlider() {
        var _this2 = this;
        var el = this.container.find(SELECTOR_FACETED_NAV_SLIDER);
        if (!el.length) return;
        if (_typeof(this.rangeSlider) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) this.rangeSlider.destroy();
        var _this$getRange = this.getRange(),
          _this$getRange2 = _slicedToArray(_this$getRange, 2),
          min = _this$getRange2[0],
          max = _this$getRange2[1];
        if (!min || min == 'min') min = 0;
        if (!max || max == 'max') max = 0;
        var rangeMin = this.getRangeMin();
        var rangeMax = this.getRangeMax();
        this.rangeElement = el[0];
        this.rangeSlider = this.noUiSlider.create(this.rangeElement, {
          start: [min ? min : rangeMin, max ? max : rangeMax],
          step: 1,
          range: {
            'min': [rangeMin],
            'max': [rangeMax]
          },
          connect: true,
          // If you want min / max to show at extremities instead of values
          // tooltips: [
          //   { to: v => this.formatMin(v <= rangeMin * 1.05 ? 'min' : v), from: true },
          //   { to: v => this.formatMax(v >= rangeMax * 0.95 ? 'max' : v), from: true }
          // ]
          tooltips: [{
            to: function to(v) {
              return _this2.formatMin(v);
            },
            from: true
          }, {
            to: function to(v) {
              return _this2.formatMax(v);
            },
            from: true
          }]
        });
        this.rangeElement.noUiSlider.on('change', function (e) {
          return _this2.onSliderUpdate(e);
        });
      }
    }, {
      key: "formatMin",
      value: function formatMin(min) {
        if (min != 'min') {
          min = printMoney(min, 'money_with_currency_format');
          min = min.split('.')[0];
        }
        return min;
      }
    }, {
      key: "formatMax",
      value: function formatMax(max) {
        if (max != 'max') {
          max = printMoney(max, 'money_with_currency_format');
          max = max.split('.')[0];
        }
        return max;
      }
    }, {
      key: "onSliderUpdate",
      value: function onSliderUpdate(e) {
        var _e2 = _slicedToArray(e, 2),
          min = _e2[0],
          max = _e2[1];
        min = parseFloat(min);
        max = parseFloat(max);
        var rangeMin = this.getRangeMin();
        var rangeMax = this.getRangeMax();

        //If within 5% of edge then snap
        if (isNaN(min) || !min || (min - rangeMin) / (rangeMax - rangeMin) < 0.05) min = 'min';
        if (isNaN(max) || !max || (rangeMax - max) / rangeMax < 0.05) max = 'max';
        this.setOptions(["".concat(min, "-").concat(max)]);
      }
    }, {
      key: "onProductsDrawn",
      value: function onProductsDrawn() {
        _get(_getPrototypeOf(_class.prototype), "onProductsDrawn", this).call(this);
        this.print();
      }
    }]);
    return _class;
  }(FacetType));
};
export var CustomPriceSlideFacet = decorateSlideFacet(PriceFacet);